import { DELETE_SHIPPING_ITEM } from "../../ActionType/ActionType"

export const deleteShippingItem=({ShippingId, itemPosition, item})=>{

    return async(dispatch, getState, {getFirebase})=>{

        dispatch({type: DELETE_SHIPPING_ITEM.REQUEST})
        
        try {
            let db =  getFirebase().firestore();

            let docRef = db.collection('shipping_orders').doc(ShippingId);

            db.runTransaction((transac)=>{
                return transac.get(docRef).then((doc)=>{
                    if(doc.exist){
                        // let shippings  = doc.data().Shippings;
                    }
                })
            })

            dispatch({type: DELETE_SHIPPING_ITEM.SUCCESS})
        } catch (error) {
            dispatch({type: DELETE_SHIPPING_ITEM.FAILURE})
            
        }
    }
}